

import React from 'react';

import Mixedplastic from './Mixedplastic';
import Mixmachinesfeatur from './Mixmachinesfeatur';
import Mixedbucktable from './Mixedbucktable';


const Mixedplasticbuc = () => {
    return (
        <div>
            <Mixedplastic />
            <Mixmachinesfeatur />
            <Mixedbucktable />

        </div>
    );
};

export default Mixedplasticbuc;
